export default __webpack_public_path__ + "static/media/VideoThumbnail7.53543093.svg";